module.exports = __webpack_public_path__ + "img/9.6a243e0b.webp";